import { VacationList } from '../../api/api-types';
import { GET_VACATION_DATA } from '../actions';

export const getVacationDataAction = (data: VacationList) =>
  GET_VACATION_DATA({ payload: data });
